import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { BaseButton } from "src/components/BaseButton";
import { useI18n } from "src/hooks/useI18n";
import { useUpdateAvailable } from "src/update/useUpdateAvailable";

/**
 * 새 버전 배포를 감지하면 새로고침을 안내하는 상단 배너
 * - 하단 액션 버튼 영역을 가리지 않도록 상단 가로 스트립으로 배치
 * - 접기 시 제거하지 않고 작은 칩으로 축소
 * - 경로 이동 시 다시 펼쳐짐
 */
function UpdateBanner() {
  const available = useUpdateAvailable({ pollIntervalMs: 10 * 60 * 1000 });
  const { pathname } = useLocation();
  const [collapsed, setCollapsed] = useState(false);
  const { t } = useI18n();

  useEffect(() => {
    setCollapsed(false);
  }, [pathname]);

  if (!available) return null;

  if (collapsed) {
    return (
      <button type="button" className="update-chip" aria-label={t("update.expand")} onClick={() => setCollapsed(false)}>
        <span className="update-chip__icon" aria-hidden="true" />
        {t("update.badge")}
      </button>
    );
  }

  return (
    <div className="update-banner" role="status">
      <p className="update-banner__message">{t("update.available")}</p>
      <div className="update-banner__actions">
        <BaseButton title={t("update.reload")} className="color-white" onClick={() => window.location.reload()} />
        <button type="button" className="update-banner__collapse" aria-label={t("update.collapse")} onClick={() => setCollapsed(true)} />
      </div>
    </div>
  );
}

export default UpdateBanner;
